import { render, staticRenderFns } from "./JbManCorretivaOpcoes.vue?vue&type=template&id=7624d1f2&"
import script from "./JbManCorretivaOpcoes.vue?vue&type=script&lang=js&"
export * from "./JbManCorretivaOpcoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports